import { TFunction } from 'i18next';
import { Step } from 'react-joyride';
import {
    AI_GENERATION_TOUR_CARD_SCROLL_OFFSET,
    AI_GENERATION_TOUR_HEADER_SCROLL_OFFSET,
    AI_GENERATION_TOUR_TARGETS,
} from './AIGenerationTour.constants';

const tourKey = (key: string) => `mannequin.aiGeneration.tour.${key}`;

export const buildAIGenerationTourSteps = (t: TFunction): Step[] => [
    {
        target: AI_GENERATION_TOUR_TARGETS.root,
        title: t(tourKey('welcome.title')),
        content: t(tourKey('welcome.content')),
        disableBeacon: true,
        placement: 'center',
        data: { scrollOffset: 0 },
    },
    {
        target: AI_GENERATION_TOUR_TARGETS.addCard,
        title: t(tourKey('addCard.title')),
        content: t(tourKey('addCard.content')),
        disableBeacon: true,
        placement: 'bottom-end',
        data: { scrollOffset: AI_GENERATION_TOUR_HEADER_SCROLL_OFFSET },
    },
    {
        target: AI_GENERATION_TOUR_TARGETS.layoutToggle,
        title: t(tourKey( 'layoutToggle.title')),
        content: t(tourKey( 'layoutToggle.content')),
        disableBeacon: true,
        placement: 'bottom',
        data: { scrollOffset: AI_GENERATION_TOUR_HEADER_SCROLL_OFFSET },
    },
    {
        target: AI_GENERATION_TOUR_TARGETS.history,
        title: t(tourKey( 'history.title')),
        content: t(tourKey( 'history.content')),
        disableBeacon: true,
        placement: 'bottom',
        data: { scrollOffset: AI_GENERATION_TOUR_HEADER_SCROLL_OFFSET },
    },
    {
        target: AI_GENERATION_TOUR_TARGETS.targetCard,
        title: t(tourKey( 'card.title')),
        content: t(tourKey( 'card.content')),
        disableBeacon: true,
        placement: 'top',
        data: { scrollOffset: AI_GENERATION_TOUR_CARD_SCROLL_OFFSET },
    },
    {
        target: AI_GENERATION_TOUR_TARGETS.statusBar,
        title: t(tourKey( 'statusBar.title')),
        content: t(tourKey( 'statusBar.content')),
        disableBeacon: true,
        placement: 'bottom',
        data: { scrollOffset: AI_GENERATION_TOUR_CARD_SCROLL_OFFSET },
    },
    {
        target: AI_GENERATION_TOUR_TARGETS.duplicateWithPhotos,
        title: t(tourKey( 'duplicateWithPhotos.title')),
        content: t(tourKey( 'duplicateWithPhotos.content')),
        disableBeacon: true,
        placement: 'bottom',
        data: { scrollOffset: AI_GENERATION_TOUR_CARD_SCROLL_OFFSET },
    },
    {
        target: AI_GENERATION_TOUR_TARGETS.duplicateCard,
        title: t(tourKey( 'duplicateCard.title')),
        content: t(tourKey( 'duplicateCard.content')),
        disableBeacon: true,
        placement: 'bottom',
        data: { scrollOffset: AI_GENERATION_TOUR_CARD_SCROLL_OFFSET },
    },
    {
        target: AI_GENERATION_TOUR_TARGETS.configSection,
        title: t(tourKey( 'configSection.title')),
        content: t(tourKey( 'configSection.content')),
        disableBeacon: true,
        placement: 'right-start',
        data: { scrollOffset: AI_GENERATION_TOUR_CARD_SCROLL_OFFSET },
    },
    {
        target: AI_GENERATION_TOUR_TARGETS.promptEditor,
        title: t(tourKey( 'promptEditor.title')),
        content: t(tourKey( 'promptEditor.content')),
        disableBeacon: true,
        placement: 'top',
        data: { scrollOffset: AI_GENERATION_TOUR_CARD_SCROLL_OFFSET },
    },
    {
        target: AI_GENERATION_TOUR_TARGETS.photosGrid,
        title: t(tourKey( 'photosGrid.title')),
        content: t(tourKey( 'photosGrid.content')),
        disableBeacon: true,
        placement: 'top',
        data: { scrollOffset: AI_GENERATION_TOUR_CARD_SCROLL_OFFSET },
    },
    {
        target: AI_GENERATION_TOUR_TARGETS.cardMenu,
        title: t(tourKey( 'cardMenu.title')),
        content: t(tourKey( 'cardMenu.content')),
        disableBeacon: true,
        placement: 'left',
        data: { scrollOffset: AI_GENERATION_TOUR_CARD_SCROLL_OFFSET },
    },
    {
        target: AI_GENERATION_TOUR_TARGETS.generateBtn,
        title: t(tourKey( 'generateBtn.title')),
        content: t(tourKey( 'generateBtn.content')),
        disableBeacon: true,
        placement: 'top',
        data: { scrollOffset: AI_GENERATION_TOUR_CARD_SCROLL_OFFSET },
    },
    {
        target: AI_GENERATION_TOUR_TARGETS.generatedSection,
        title: t(tourKey( 'generatedSection.title')),
        content: t(tourKey( 'generatedSection.content')),
        disableBeacon: true,
        placement: 'top',
        data: { scrollOffset: AI_GENERATION_TOUR_CARD_SCROLL_OFFSET },
    },
];
